import React, {FunctionComponent, NamedExoticComponent, useEffect} from "react";
import {useRerender} from "./useRerender";

let animationHandler: number;

const onFrame = () => {
    listeners.forEach((action) => action());
    animationHandler = requestAnimationFrame(onFrame);
};

animationHandler = requestAnimationFrame(onFrame);

const listeners: Function[] = [];

export const useAnimationFrame = (action: () => void, deps?: any[]) => {
    useEffect(() => {
        listeners.push(action);

        return () => {
            listeners.splice(listeners.indexOf(action), 1);
        };
    }, deps);
};

export const useAnimate = () => {
    const rerender = useRerender();
    useAnimationFrame(rerender, []);
};
